import { DateFilter, DateFilterType } from '../AppointmentsFilterChips/DateChipFilter.types';

import { FilterFormBean } from './AppointmentsFilterPanel';

export const createDateFilter = (dateFilter: DateFilter | null): FilterFormBean['date'] => {
   if (!dateFilter) {
      return { type: null };
   }

   if (dateFilter.type === DateFilterType.TODAY || dateFilter.type === DateFilterType.DAY) {
      return { type: DateFilterType.DAY, day: dateFilter.range.lowerEndpoint() };
   }

   if (dateFilter.type === DateFilterType.RANGE) {
      return { type: DateFilterType.RANGE, range: dateFilter.range };
   }

   return { type: null };
};
